import { type JsonDataItem } from 'types';
import { baseQuery } from '../baseQuery';

export const putSearchHistory = async ({ searchId, customerId }: JsonDataItem) => {
  const { data } = await baseQuery('search-history', {
    type: 'PUT',
    body: {
      search_history_id: searchId,
      customer_id: customerId,
    },
  });

  return data;
};
